import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateSpherePositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const radius = 55;
  const height = radius * 2;
  const goldenAngle = Math.PI * (3 - Math.sqrt(5));

  // Sort by PnL descending
  const sorted = starsData.map((_, i) => i).sort((a, b) => starsData[b].pnl - starsData[a].pnl);
  const count = sorted.length;
  const positions: StarPosition[] = new Array(count);

  sorted.forEach((idx, rank) => {
    const t = rank / count;
    const y = radius - t * height;
    const yNorm = y / radius;
    const sliceRadius = radius * Math.sqrt(Math.max(0, 1 - yNorm * yNorm));
    const theta = rank * goldenAngle;
    const r = sliceRadius * (0.85 + Math.random() * 0.15);

    positions[idx] = {
      x: Math.cos(theta) * r + (Math.random() - 0.5) * 1.5,
      y: y + (Math.random() - 0.5) * 1,
      z: Math.sin(theta) * r + (Math.random() - 0.5) * 1.5,
    };
  });

  return positions;
};
